import Oidc, { UserManager } from 'oidc-client';

export const getAuthToken = async (oidcConfig) => {
  const userManager = new UserManager(oidcConfig);
  const user = await userManager.getUser();
  if (user) return user.access_token;
  return null;
};

export const userHasAllPermissions = (userPermissions, ...permissions) =>
  permissions.every((p) => userPermissions.indexOf(p) > -1);

export const userHasSomePermissions = (userPermissions, ...permissions) =>
  permissions.some((p) => userPermissions.indexOf(p) > -1);

export const loginAsync = async (oidcConfig) => {
  const userManager = new Oidc.UserManager(oidcConfig);
  const user = await userManager.getUser();
  if (!user || user.expired) {
    return userManager.signinRedirect();
  }
  return user;
};

export const signOut = (oidcConfig) => {
  const userManager = new Oidc.UserManager(oidcConfig);
  return userManager.signoutRedirect();
};
